'use client';
import React, { useState } from 'react';

const SkipNavigation = ({ 
  href = "#main", 
  text = "Saltar para o conteúdo",
  className = "",
  containerClass = ""
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleFocus = () => {
    setIsVisible(true);
  };

  const handleBlur = () => {
    setIsVisible(false);
  };

  const handleClick = () => {
    setIsVisible(false);
  };

  return (
    <div 
      className={`bg-primary-100 ${containerClass}`}
    >
      <div className="container mx-auto">
        <div 
          className={`agora-skip-navigation bg-primary-100 container mx-auto py-16 ${isVisible ? 'show' : ''}`}
        >
          <span className="agora-link-wrapper agora-link-wrapper-text-primary inline-flex items-center justify-start">
            <a 
              href={href} 
              className={`skip-item ${className}`}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onClick={handleClick}
            >
              {text}
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SkipNavigation;